import { ChannelSelectionDropDown } from 'open-modules/zdf/component/channels/channel-dropdown';
import { Feature } from "util/stdtypes";

export const ChannelSelectionModDashboardFeature : Feature<any, {}> = {
    name: 'Channel Selection (Mod Dashboard)',
    key: 'channelselectionmoddashboard',
    parentFeature: "channelbase",
    providesConfig: {
        moddashboardTopBarWidgets: [ChannelSelectionDropDown]
    }
}